import React, { Component } from 'react';

export class Source extends Component {

    handleSourceChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        this.props.specificChanges(name, value);
    }

    render() {
        return (
            <div className="form-horizontal row spacer">
                <label className="control-label col-sm-4" htmlFor="Source">What was the source of the noise?</label>
                <div className="col-sm-8">
                    <input className="form-control" type="text" name="noiseSource" onBlur={this.handleSourceChange} placeholder="e.g. Band, Patrons, DJ" maxLength={100}/>
                </div>
            </div >
        );
    }
}
export default Source;



// WEBPACK FOOTER //
// ./src/components/questions/Source.jsx